import React from "react";
import useStyles from "./styles";
import dayjs from "dayjs";
import Verified from "../../assets/svg/verified.svg";
import InformationProprietaire from "../../assets/svg/InformationProprietaire.svg";

type TEvent = {
  eventType: string;
  date: string;
  who: string;
  data?: {
    vin?: string;
    ownerId?: string;
    linkedFiles?: any[];
    data?: string;
    number?: string;
    brand?: string;
    model?: string;
    pictureCid?: string | null;
    identificationId?: string;
    type?: string;
    antiTheftNumber?: string | null;
    registerStep?: string;
    gearBox?: string;
    power?: string;
    fuel?: string;
    dateOfFirstRegistration?: string;
    status?: string | null;
    name?: string;
    note?: string;
    url_report?: string[];
    eventType?: string;
    date?: string;
  };
};

type Props = {
  historique: TEvent;
  isVerified?: boolean;
};

export const HistoriqueItem: React.FC<Props> = ({ historique, isVerified }) => {
  const classes = useStyles();

  const formatDate = (dateString: string) => {
    try {
      return dayjs(dateString).format("DD/MM/YYYY");
    } catch (error) {
      return dateString;
    }
  };

  const getEventTypeDisplay = (eventType: string) => {
    switch (eventType) {
      case "VEHICLE_CREATION":
        return "Création du véhicule";
      case "MAINTENANCE":
        return "Entretien";
      case "REPAIR":
        return "Réparation";
      case "INSPECTION":
        return "Contrôle technique";
      case "ACCIDENT":
        return "Accident";
      case "SALE":
        return "Vente";
      default:
        return eventType;
    }
  };

  const renderVehicleInfo = () => {
    if (!historique.data) return null;

    const vehicleData = historique.data;
    const hasVehicleInfo = vehicleData.brand || vehicleData.model || vehicleData.number;

    if (!hasVehicleInfo) return null;

    return (
      <div className="vehicle-info">
        <div className="vehicle-info-title">Informations du véhicule:</div>
        
        {vehicleData.brand && (
          <div className="vehicle-info-item">
            <span className="label">Marque:</span>
            <span className="value">{vehicleData.brand}</span>
          </div>
        )}
        
        {vehicleData.model && (
          <div className="vehicle-info-item">
            <span className="label">Modèle:</span>
            <span className="value">{vehicleData.model}</span>
          </div>
        )}
        
        {vehicleData.number && (
          <div className="vehicle-info-item">
            <span className="label">Immatriculation:</span>
            <span className="value">{vehicleData.number}</span>
          </div>
        )}
        
        {vehicleData.vin && (
          <div className="vehicle-info-item">
            <span className="label">VIN:</span>
            <span className="value">{vehicleData.vin}</span>
          </div>
        )}
        
        {vehicleData.gearBox && (
          <div className="vehicle-info-item">
            <span className="label">Boîte:</span>
            <span className="value">{vehicleData.gearBox}</span>
          </div>
        )}
        
        {vehicleData.fuel && (
          <div className="vehicle-info-item">
            <span className="label">Carburant:</span>
            <span className="value">{vehicleData.fuel}</span>
          </div>
        )}
        
        {vehicleData.power && (
          <div className="vehicle-info-item">
            <span className="label">Puissance:</span>
            <span className="value">{vehicleData.power}</span>
          </div>
        )}
        
        {vehicleData.dateOfFirstRegistration && (
          <div className="vehicle-info-item">
            <span className="label">Date de mise en circulation:</span>
            <span className="value">{formatDate(vehicleData.dateOfFirstRegistration)}</span>
          </div>
        )}
        
        {vehicleData.type && (
          <div className="vehicle-info-item">
            <span className="label">Type:</span>
            <span className="value">{vehicleData.type}</span>
          </div>
        )}
        
        {vehicleData.status && (
          <div className="vehicle-info-item">
            <span className="label">Statut:</span>
            <span className="value">{vehicleData.status}</span>
          </div>
        )}
      </div>
    );
  };

  const renderDocuments = () => {
    if (!historique.data?.url_report || historique.data.url_report.length === 0) {
      return null;
    }

    return (
      <div className={classes.documentsContainer}>
        <div className="documents-label">Documents:</div>
        <div className={classes.documentsList}>
          {historique.data.url_report.map((url, index) => (
            <a
              key={index}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.documentLink}
            >
              Document {index + 1}
            </a>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className={classes.historiqueItemContainer}>
      <div className={classes.iconVerification}>
        {isVerified ? (
          <img src={Verified} alt="Verified" />
        ) : (
          <img src={InformationProprietaire} alt="Owner Info" />
        )}
      </div>
      
      <div className={classes.historiqueRow}>
        <div className="year">{formatDate(historique.date)}</div>
        <div className="revision">{getEventTypeDisplay(historique.eventType)}</div>
        <div style={{ flex: 1 }}>
          <div>Par: {historique.who}</div>
          {renderVehicleInfo()}
        </div>
      </div>
      
      {historique.data?.note && (
        <div className={classes.notes}>
          <div className="notes">Notes:</div>
          <p>{historique.data.note}</p>
        </div>
      )}
      
      {renderDocuments()}
    </div>
  );
};